import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Breadcrumbs from '@cotyorg/ccx-molecules/Breadcrumbs';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import PropTypes from 'prop-types';
import R from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import SectionHeader from '../../atoms/SectionHeader';
import Table from '../../molecules/Table';
import PageDescription from '../../organisms/PageDescription/PageDescription';
import StandardLayout from '../../templates/StandardLayout';

const mapIndex = R.addIndex(R.map);

const VtoPrivacyPolicyComponent = ({
  breadcrumb,
  sectionHeadings,
  sectionPrivacyPolicy,
  terms,
}) => (
  <StandardLayout>
    <SectionHeader extraClass="vto-privacy-policy__header">
      <div className="grid-container">
        <div className="grid-x">
          <div className="cell">
            <Breadcrumbs items={breadcrumb} />
          </div>
        </div>
      </div>

      <PageDescription
        level={2}
        heading={R.path(['introductionSection', 'heading'], sectionHeadings)}
        text={R.path(['introductionSection', 'subheading'], sectionHeadings)}
      />
    </SectionHeader>

    <div className="vto-privacy-policy__page-content">
      <div className="grid-container">
        <div className="grid-x">
          <div className="cell xsmall-16 large-12 large-offset-2">
            <OptionalSection
              renderCondition={R.has('introduction', sectionPrivacyPolicy)}
              section={() => (
                <div className="vto-privacy-policy__introduction">
                  <Paragraph>
                    {R.prop('introduction', sectionPrivacyPolicy)}
                  </Paragraph>
                </div>
              )}
            />

            <OptionalSection
              renderCondition={R.has('title', sectionPrivacyPolicy)}
              section={() => (
                <div className="vto-privacy-policy__terms-title">
                  <Heading level={2}>
                    {R.prop('title', sectionPrivacyPolicy)}
                  </Heading>
                </div>
              )}
            />

            <OptionalSection
              renderCondition={R.length(terms) > 0}
              section={() => (
                <div className="vto-privacy-policy__terms-list">
                  {mapIndex(
                    (term, rowIndex) => (
                      <div key={rowIndex} className="vto-privacy-policy__term">
                        <div className="vto-privacy-policy__term-content">
                          <Heading level={3}>{R.prop('title', term)}</Heading>

                          <Paragraph>{R.prop('description', term)}</Paragraph>
                        </div>

                        <OptionalSection
                          renderCondition={R.length(R.prop('table', term)) > 0}
                          section={() => (
                            <div className="vto-privacy-policy__term-table-wrapper">
                              <Table rows={R.prop('table', term)} />
                            </div>
                          )}
                        />
                      </div>
                    ),
                    terms
                  )}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

VtoPrivacyPolicyComponent.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  sectionPrivacyPolicy: PropTypes.objectOf(PropTypes.object),
  terms: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = ({ content }) => ({
  breadcrumb: R.prop('breadcrumb', content),
  sectionHeadings: R.prop('sectionHeadings', content),
  sectionPrivacyPolicy: R.prop('sectionPrivacyPolicy', content),
  terms: R.prop('terms', content),
});

export default connect(mapStateToProps)(VtoPrivacyPolicyComponent);
